/* Knuffel custom-checkout handoff.
 *
 * Product/plan IDs and quantity always come from Shopify-rendered allocation or
 * cart data. Tracking context is never appended to a URL. The merchant-selected
 * trackingConsentMode controls whether it is collected for every visitor or is
 * gated by Shopify Customer Privacy.
 */
(function () {
  "use strict";

  var configEl = document.getElementById("jc-checkout-config");
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent || "{}"); } catch (_) { return; }

  function checkoutOrigin(value) {
    try {
      var url = new URL(value);
      var isLocal = url.hostname === "localhost" || url.hostname === "127.0.0.1";
      if (url.protocol !== "https:" && !(isLocal && url.protocol === "http:")) return "";
      if (url.username || url.password) return "";
      return url.origin;
    } catch (_) { return ""; }
  }

  var origin = checkoutOrigin(config.origin);
  if (!origin) return;
  var trackingConsentMode = config.trackingConsentMode === "consent_aware" ? "consent_aware" : "track_all";

  function recordTrackingModeMismatch(serverMode) {
    var detail = {
      themeMode: trackingConsentMode,
      serverMode: serverMode,
      detectedAt: new Date().toISOString()
    };
    window.JCTrackingModeMismatch = detail;
    if (window.JCCheckout) window.JCCheckout.lastTrackingModeMismatch = detail;
    try { console.warn("Knuffel tracking-mode mismatch", detail); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent("jc:tracking-mode-mismatch", { detail: detail })); } catch (_) {}
  }

  function numericId(value) {
    var match = String(value == null ? "" : value).match(/(?:^|\/)(\d+)$/);
    return match ? match[1] : "";
  }

  function gid(kind, value) {
    var id = numericId(value);
    return id ? "gid://shopify/" + kind + "/" + id : "";
  }

  function checkoutQuantity(value) {
    var parsed = Number(value);
    return Number.isInteger(parsed) && parsed >= 1 && parsed <= 50 ? parsed : 0;
  }

  function fallbackError(reason, message) {
    var error = new Error(message || reason);
    error.name = "NativeShopifyCheckoutFallback";
    error.checkoutFallbackReason = reason;
    return error;
  }

  function country(value) {
    var code = String(value || config.country || "DE").toUpperCase();
    return /^[A-Z]{2}$/.test(code) ? code : "DE";
  }

  function pdpSurface(value) {
    return value === "subscription_alt" ? "subscription_alt" : "";
  }

  function base64Url(bytes) {
    var binary = "";
    for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  function randomBytes(length) {
    var bytes = new Uint8Array(length);
    if (window.crypto && typeof crypto.getRandomValues === "function") return crypto.getRandomValues(bytes);
    for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    return bytes;
  }

  function experimentSubject() {
    var key = "knuffel_exp_subject";
    try {
      var existing = localStorage.getItem(key) || sessionStorage.getItem(key);
      if (/^anon_[A-Za-z0-9_-]{16,64}$/.test(existing || "")) return existing;
      var next = "anon_" + base64Url(randomBytes(18));
      localStorage.setItem(key, next);
      sessionStorage.setItem(key, next);
      return next;
    } catch (_) {
      return "anon_" + base64Url(randomBytes(18));
    }
  }

  function consentState() {
    var state = window.JCTrackingConsent || {};
    if (trackingConsentMode === "track_all") {
      return {
        analytics: true,
        marketing: true,
        saleOfData: true,
        consentId: "",
        country: country(config.country),
        globalPrivacyControl: false,
        explicitOptOut: false,
        explicitAnalyticsOptOut: false,
        visitorAnalytics: "not_required",
        visitorMarketing: "not_required",
        shopifyAnalyticsAllowed: true,
        shopifyMarketingAllowed: true,
        shopifySaleOfDataAllowed: true
      };
    }
    return {
      analytics: state.analytics === true,
      marketing: state.marketing === true,
      saleOfData: state.saleOfData === true,
      consentId: typeof state.consentId === "string" ? state.consentId.slice(0, 128) : "",
      country: /^[A-Z]{2}$/.test(String(state.country || "").toUpperCase()) ? String(state.country).toUpperCase() : country(config.country),
      globalPrivacyControl: state.globalPrivacyControl === true || navigator.globalPrivacyControl === true,
      explicitOptOut: state.explicitOptOut === true,
      explicitAnalyticsOptOut: state.explicitAnalyticsOptOut === true,
      visitorAnalytics: String(state.visitorAnalytics || ""),
      visitorMarketing: String(state.visitorMarketing || ""),
      shopifyAnalyticsAllowed: state.shopifyAnalyticsAllowed === true,
      shopifyMarketingAllowed: state.shopifyMarketingAllowed === true,
      shopifySaleOfDataAllowed: state.shopifySaleOfDataAllowed === true
    };
  }

  function analyticsPermissionMode(consent) {
    if (trackingConsentMode === "track_all") return "tracking_default";
    if (consent.globalPrivacyControl || consent.explicitAnalyticsOptOut || !consent.analytics ||
        !consent.shopifyAnalyticsAllowed) return "denied";
    if (consent.visitorAnalytics === "yes") return "explicit_opt_in";
    return consent.country === "US" ? "us_opt_out_default" : "denied";
  }

  function adsPermissionMode(consent) {
    if (trackingConsentMode === "track_all") return "tracking_default";
    if (consent.globalPrivacyControl || consent.explicitOptOut || !consent.marketing || !consent.saleOfData ||
        !consent.shopifyMarketingAllowed || !consent.shopifySaleOfDataAllowed) return "denied";
    if (consent.visitorMarketing === "yes") return "explicit_opt_in";
    return consent.country === "US" ? "us_opt_out_default" : "denied";
  }

  function cookie(name) {
    var prefix = name + "=";
    var rows = document.cookie ? document.cookie.split(";") : [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i].trim();
      if (row.indexOf(prefix) === 0) {
        try { return decodeURIComponent(row.slice(prefix.length)); } catch (_) { return row.slice(prefix.length); }
      }
    }
    return "";
  }

  function validFbp(value) { return /^fb\.1\.\d{10,16}\.\d{5,32}$/.test(value || ""); }
  function validFbc(value) { return /^fb\.1\.\d{10,16}\.[A-Za-z0-9_-]{5,250}$/.test(value || ""); }
  function validFbclid(value) { return /^[A-Za-z0-9_-]{5,250}$/.test(value || ""); }
  function validAnalyticsId(value) { return /^[A-Za-z0-9_.-]{8,128}$/.test(value || ""); }

  function shopifyPixelContext() {
    // Shopify's internal analytics cookies are not a public API and the
    // _shopify_y/_shopify_s cookies were retired in 2026. The companion Web
    // Pixel may deliberately bridge event.clientId through our own first-party
    // cookie; an app can alternatively expose validated, non-PII IDs through
    // JCShopifyPixelContext. Omit fields rather than fabricating identifiers.
    var bridgedClientId = cookie("knuffel_shopify_pixel_client_id");
    var value = window.JCShopifyPixelContext;
    var context = {};
    if (validAnalyticsId(bridgedClientId)) context.clientId = bridgedClientId;
    if (value && typeof value === "object") {
      if (!context.clientId && validAnalyticsId(String(value.clientId || ""))) context.clientId = String(value.clientId);
      if (validAnalyticsId(String(value.sessionId || ""))) context.sessionId = String(value.sessionId);
    }
    return context;
  }

  function cleanAttributionValue(value) {
    var cleaned = String(value || "").replace(/[\u0000-\u001f\u007f]/g, "").trim().slice(0, 200);
    return cleaned.indexOf("@") === -1 ? cleaned : "";
  }

  function storefrontUrl(value) {
    try {
      var url = new URL(value, location.origin);
      if (location.protocol !== "https:" || url.protocol !== "https:" || url.origin !== location.origin) return "";
      url.username = "";
      url.password = "";
      url.search = "";
      url.hash = "";
      return url.toString();
    } catch (_) { return ""; }
  }

  function referrerUrl(value) {
    try {
      if (!value) return "";
      var url = new URL(value);
      if (url.protocol !== "https:" || url.username || url.password) return "";
      url.search = "";
      url.hash = "";
      return url.toString();
    } catch (_) { return ""; }
  }

  function readFirstTouch() {
    var key = "knuffel_first_touch_v3";
    var ttl = 90 * 24 * 60 * 60 * 1000;
    try {
      var stored = JSON.parse(localStorage.getItem(key) || sessionStorage.getItem(key) || "null");
      if (stored && typeof stored === "object" && stored.landingUrl &&
        Number.isFinite(stored.capturedAt) && Date.now() - stored.capturedAt <= ttl) return stored;
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (_) {}

    var params = new URLSearchParams(location.search);
    var utm = {};
    ["source", "medium", "campaign", "term", "content"].forEach(function (name) {
      var value = cleanAttributionValue(params.get("utm_" + name));
      if (value) utm[name] = value;
    });
    var touch = {
      capturedAt: Date.now(),
      landingUrl: storefrontUrl(location.href),
      referrerUrl: referrerUrl(document.referrer),
      utm: utm
    };
    try { localStorage.setItem(key, JSON.stringify(touch)); } catch (_) {}
    try { sessionStorage.setItem(key, JSON.stringify(touch)); } catch (_) {}
    return touch;
  }

  var firstTouch = null;
  var firstTouchKey = "knuffel_first_touch_v3";
  var marketingClickKey = "knuffel_marketing_click_v2";
  var attributionTtl = 90 * 24 * 60 * 60 * 1000;
  function captureAllowedFirstTouch() {
    var consent = consentState();
    if (analyticsPermissionMode(consent) === "denied" && adsPermissionMode(consent) === "denied") return;
    firstTouch = readFirstTouch();
  }
  function captureAllowedMarketingClick() {
    var consent = consentState();
    if (adsPermissionMode(consent) === "denied") return;
    var value = new URLSearchParams(location.search).get("fbclid") || "";
    if (!validFbclid(value)) return;
    var stored = JSON.stringify({ value: value, capturedAt: Date.now() });
    try { localStorage.setItem(marketingClickKey, stored); } catch (_) {}
    try { sessionStorage.setItem(marketingClickKey, value); } catch (_) {}
  }
  function rememberedFbclid() {
    captureAllowedMarketingClick();
    try {
      var persisted = JSON.parse(localStorage.getItem(marketingClickKey) || "null");
      if (persisted && validFbclid(persisted.value) && Number.isFinite(persisted.capturedAt) &&
        Date.now() - persisted.capturedAt <= attributionTtl) return persisted.value;
      localStorage.removeItem(marketingClickKey);
      var sessionValue = sessionStorage.getItem(marketingClickKey) || "";
      return validFbclid(sessionValue) ? sessionValue : "";
    } catch (_) { return ""; }
  }
  function clearStoredAttribution() {
    firstTouch = null;
    try {
      localStorage.removeItem(firstTouchKey);
      localStorage.removeItem(marketingClickKey);
      sessionStorage.removeItem(firstTouchKey);
      sessionStorage.removeItem(marketingClickKey);
    } catch (_) {}
  }
  function captureAllowedAttribution() {
    var consent = consentState();
    if (analyticsPermissionMode(consent) === "denied" && adsPermissionMode(consent) === "denied") {
      clearStoredAttribution();
      return;
    }
    captureAllowedFirstTouch();
    captureAllowedMarketingClick();
  }
  document.addEventListener("jc:tracking-consent", captureAllowedAttribution);
  captureAllowedAttribution();

  function trackingContext(pdpVariant) {
    var consent = consentState();
    var analyticsMode = analyticsPermissionMode(consent);
    var adsMode = adsPermissionMode(consent);
    var analyticsAllowed = analyticsMode !== "denied";
    var adsAllowed = adsMode !== "denied";
    captureAllowedFirstTouch();
    var touch = firstTouch || {};
    var tracking = {
      adsConsent: adsAllowed,
      adsConsentVersion: "2026-08-22",
      adsPermissionMode: adsMode,
      globalPrivacyControl: consent.globalPrivacyControl,
      shopifyPrivacyAnalyticsAllowed: consent.shopifyAnalyticsAllowed,
      shopifyPrivacyMarketingAllowed: consent.shopifyMarketingAllowed,
      shopifyPrivacySaleOfDataAllowed: consent.shopifySaleOfDataAllowed,
      analyticsConsent: analyticsAllowed,
      analyticsPermissionMode: analyticsMode,
      analyticsConsentVersion: "2026-08-22"
    };

    if (analyticsAllowed && window.posthog) {
      try {
        var distinctId = posthog.get_distinct_id ? String(posthog.get_distinct_id() || "") : "";
        var posthogSessionId = posthog.get_session_id ? String(posthog.get_session_id() || "") : "";
        if (validAnalyticsId(distinctId)) tracking.posthogDistinctId = distinctId;
        if (validAnalyticsId(posthogSessionId)) tracking.posthogSessionId = posthogSessionId;
      } catch (_) {}
    }
    if (analyticsAllowed) {
      tracking.experimentSubject = experimentSubject();
      tracking.experiment = { key: "pdp-checkout", variant: presentationVariant(pdpVariant) };
      if (touch.landingUrl) tracking.landingUrl = touch.landingUrl;
      if (touch.referrerUrl) tracking.referrerUrl = touch.referrerUrl;
      var pixelContext = shopifyPixelContext();
      if (pixelContext.clientId) tracking.shopifyWebPixelClientId = pixelContext.clientId;
      if (pixelContext.sessionId) tracking.shopifyWebPixelSessionId = pixelContext.sessionId;
    }

    if (adsAllowed) {
      var fbp = cookie("_fbp");
      var fbc = cookie("_fbc");
      var fbclid = rememberedFbclid();
      if (validFbp(fbp)) tracking.fbp = fbp;
      if (validFbc(fbc)) tracking.fbc = fbc;
      if (validFbclid(fbclid)) tracking.fbclid = fbclid;
    }
    if ((analyticsAllowed || adsAllowed) && touch.utm && Object.keys(touch.utm).length) tracking.utm = touch.utm;

    return tracking;
  }

  function fetchJson(url, options, timeout) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, timeout || 5000);
    options = options || {};
    options.signal = controller.signal;
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.json();
    }).finally(function () { clearTimeout(timer); });
  }

  function requestOfferAssignment(input) {
    var variantId = numericId(input.variantId);
    var planId = numericId(input.entrySellingPlanId);
    var quantity = checkoutQuantity(input.quantity);
    if (!variantId || !planId || !quantity) return Promise.reject(fallbackError("invalid_checkout_quantity", "Invalid Shopify offer"));
    return fetchJson(origin + "/api/posthog/offer-assignment", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        productVariantId: gid("ProductVariant", variantId),
        entrySellingPlanId: gid("SellingPlan", planId),
        countryCode: country(input.countryCode),
        quantity: quantity,
        subject: experimentSubject()
      })
    }, 3500).then(function (result) {
      var selected = numericId(result && result.selectedSellingPlanId);
      if (!selected || !result || typeof result.assignmentToken !== "string") {
        throw new Error("Invalid offer assignment response");
      }
      result.selectedSellingPlanNumericId = selected;
      return result;
    });
  }

  function requestCommerceOffer(input) {
    var variantId = numericId(input.variantId);
    var planId = numericId(input.sellingPlanId);
    var quantity = checkoutQuantity(input.quantity);
    if (!variantId || !planId || !quantity) return Promise.reject(fallbackError("invalid_checkout_quantity", "Invalid commerce offer"));
    return fetchJson(origin + "/api/offers/resolve", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        productVariantId: gid("ProductVariant", variantId),
        sellingPlanId: gid("SellingPlan", planId),
        countryCode: country(input.countryCode),
        quantity: quantity,
        subject: experimentSubject()
      })
    }, 3500).then(function (result) {
      if (!result || result.offer == null) return null;
      var offer = result.offer;
      if (typeof offer.offerToken !== "string" || !offer.offerToken || numericId(offer.productVariantId) !== variantId ||
          numericId(offer.sellingPlanId) !== planId || offer.countryCode !== country(input.countryCode) || Number(offer.quantity) !== quantity) {
        throw new Error("Invalid commerce offer response");
      }
      return offer;
    });
  }

  function requestCommercePresentation(input) {
    var variantId = numericId(input.variantId);
    if (!variantId) return Promise.reject(new Error("Invalid commerce presentation variant"));
    return fetchJson(origin + "/api/offers/pdp", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        productVariantId: gid("ProductVariant", variantId),
        countryCode: country(input.countryCode),
        subject: experimentSubject()
      })
    }, 7000).then(function (result) {
      if (!result || result.offer == null) return null;
      if (numericId(result.offer.variant && result.offer.variant.productVariantId) !== variantId) throw new Error("Invalid commerce presentation response");
      return result.offer;
    });
  }

  function createHandoff(input) {
    var variantId = numericId(input.variantId);
    var planId = numericId(input.sellingPlanId);
    var quantity = checkoutQuantity(input.quantity);
    if (!variantId || !planId) return Promise.reject(new Error("Custom checkout requires a subscription line"));
    if (!quantity) return Promise.reject(fallbackError("invalid_checkout_quantity", "Custom checkout quantity must be between 1 and 50"));

    var body = {
      variantId: variantId,
      entrySellingPlanId: numericId(input.entrySellingPlanId) || planId,
      sellingPlanId: planId,
      quantity: quantity,
      countryCode: country(input.countryCode),
      pdpSurface: pdpSurface(input.pdpSurface) || undefined,
      trackingConsentMode: trackingConsentMode,
      experimentAssignmentToken: input.experimentAssignment || undefined,
      commerceOfferToken: input.commerceOfferToken || undefined,
      tracking: trackingContext(input.pdpVariant)
    };

    return fetchJson(origin + "/api/storefront-handoff", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }, 5000).then(function (result) {
      if (!result || typeof result.handoffToken !== "string" || !result.handoffToken) {
        throw new Error("Invalid checkout handoff response");
      }
      var serverTrackingMode = result.trackingConsentMode === "consent_aware" || result.trackingConsentMode === "track_all"
        ? result.trackingConsentMode
        : "unknown";
      window.JCCheckoutServerTrackingConsentMode = serverTrackingMode;
      if (serverTrackingMode !== trackingConsentMode) recordTrackingModeMismatch(serverTrackingMode);
      if (typeof result.checkoutUrl !== "string" || !result.checkoutUrl) throw new Error("Missing checkout redirect");
      var target = new URL(result.checkoutUrl);
      if (target.origin !== origin || target.protocol !== new URL(origin).protocol) throw new Error("Unsafe checkout redirect");
      if (target.pathname !== "/api/storefront-handoff/consume" || target.searchParams.get("token") !== result.handoffToken) {
        throw new Error("Unexpected checkout redirect");
      }
      return target.toString();
    });
  }

  function lineExperiment(properties) {
    properties = properties || {};
    var key = properties._knuffel_experiment_key;
    var variant = properties._knuffel_experiment_variant;
    var assignmentId = properties._knuffel_experiment_assignment_id;
    return key && variant && assignmentId ? { key: String(key), variant: String(variant), assignmentId: String(assignmentId) } : null;
  }

  function presentationVariant(value) {
    value = String(value || "");
    return /^(control|sub_first|otp_only)$/.test(value) ? value : "control";
  }

  function capture(name, properties) {
    if (analyticsPermissionMode(consentState()) === "denied" || !window.posthog || !posthog.capture) return;
    try { posthog.capture(name, properties || {}); } catch (_) {}
  }

  function hasDiscountApplications(cart) {
    if (!cart || typeof cart !== "object") return false;
    function populated(value) { return Array.isArray(value) && value.length > 0; }
    var items = Array.isArray(cart.items) ? cart.items : [];
    var signedLine = items.length === 1 ? items[0] : null;
    var signedProperties = signedLine && signedLine.properties || {};
    var signedQuantity = Number(signedProperties._knuffel_commerce_quantity);
    var signedFirstAmount = Number(signedProperties._knuffel_commerce_first_amount);
    var signedOfferMatchesCart = Boolean(
      signedProperties._knuffel_commerce_offer_token &&
      Number.isInteger(signedQuantity) && signedQuantity > 0 &&
      Number.isInteger(signedFirstAmount) && signedFirstAmount >= 0 &&
      Number(signedLine.quantity) === signedQuantity
    );
    if (populated(cart.cart_level_discount_applications) || populated(cart.discount_codes)) return true;
    // Shopify represents the configured first-cycle subscription price as a
    // line discount. It is safe only when the resulting cart quantity and line
    // total exactly match the signed commerce offer; all other discounts stay
    // on Shopify Checkout.
    if (signedOfferMatchesCart) return false;
    if (populated(cart.discount_applications)) return true;
    return items.some(function (line) {
      return populated(line && line.line_level_discount_allocations) ||
        populated(line && line.discount_allocations) || populated(line && line.discounts);
    });
  }

  function announceCheckoutFailure(reason) {
    var detail = { reason: reason || "handoff_failed" };
    try { sessionStorage.setItem("knuffel_checkout_error_reason", detail.reason); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent("jc:checkout-error", { detail: detail })); } catch (_) {}
    try { console.warn("Knuffel custom checkout unavailable", detail); } catch (_) {}
    capture("checkout_blocked", detail);
  }

  function eligibleCartLine(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    if (items.length !== 1) return null;
    var line = items[0];
    var allocation = line && line.selling_plan_allocation;
    var plan = allocation && allocation.selling_plan;
    var planId = numericId(plan && plan.id);
    if (!line || !numericId(line.variant_id) || !planId) return null;
    return {
      variantId: numericId(line.variant_id),
      entrySellingPlanId: numericId(line.properties && line.properties._knuffel_entry_selling_plan) || planId,
      sellingPlanId: planId,
      quantity: line.quantity,
      countryCode: config.country,
      experimentAssignment: line.properties && line.properties._knuffel_experiment_assignment,
      commerceOfferToken: line.properties && line.properties._knuffel_commerce_offer_token,
      experiment: lineExperiment(line.properties),
      pdpSurface: pdpSurface(line.properties && line.properties._knuffel_pdp_surface),
      pdpVariant: presentationVariant(cart.attributes && cart.attributes._ph_variant)
    };
  }

  function cartCheckoutUrl() {
    return fetchJson((window.Theme && Theme.routes && Theme.routes.cart_url ? Theme.routes.cart_url : "/cart") + ".js", {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    }, 4000).then(function (cart) {
      if (hasDiscountApplications(cart)) {
        throw fallbackError(
          "discount_applications_require_shopify_checkout",
          "Shopify discounts must remain in native Shopify Checkout"
        );
      }
      var input = eligibleCartLine(cart);
      if (!input) throw fallbackError("cart_not_eligible", "Cart is not eligible for the subscription checkout");
      capture("initiate_checkout", {
        variant_id: input.variantId,
        quantity: input.quantity,
        subscription: true,
        selling_plan: input.sellingPlanId,
        entry_selling_plan: input.entrySellingPlanId,
        pdp_variant: input.pdpVariant,
        offer_experiment: input.experiment && input.experiment.key || null,
        offer_variant: input.experiment && input.experiment.variant || null,
        pdp_surface: input.pdpSurface || null
      });
      return createHandoff(input);
    });
  }

  var checkoutBusy = false;
  function redirectCartToCheckout() {
    if (checkoutBusy) return Promise.resolve(false);
    checkoutBusy = true;
    return cartCheckoutUrl().then(function (url) {
      location.assign(url);
      return true;
    }).catch(function (error) {
      var reason = error && error.checkoutFallbackReason || "handoff_failed";
      if (reason === "handoff_failed") capture("checkout_handoff_error", { reason: error && error.name || reason });
      announceCheckoutFailure(reason);
      // The app offer can have a signed price and free lines that Shopify's
      // native checkout cannot reproduce. Never fall through to a differently
      // priced Shopify checkout; keep the customer on the current surface and
      // let it show a retryable error.
      throw error;
    }).finally(function () {
      checkoutBusy = false;
    });
  }

  document.addEventListener("submit", function (event) {
    var submitter = event.submitter;
    if (!submitter || (submitter.id !== "checkout" && submitter.name !== "checkout")) return;
    // The existing PDP and every ordinary Shopify cart must remain byte-for-byte
    // on Shopify's native checkout path. Liquid adds this marker only when the
    // cart contains the signed, one-line alternate-PDP subscription offer.
    if (submitter.getAttribute("data-jc-custom-checkout") !== "true") return;
    if (checkoutBusy) { event.preventDefault(); return; }
    event.preventDefault();
    submitter.disabled = true;
    submitter.setAttribute("aria-busy", "true");

    redirectCartToCheckout().finally(function () {
      submitter.disabled = false;
      submitter.removeAttribute("aria-busy");
    });
  }, true);

  window.JCCheckout = {
    origin: origin,
    trackingConsentMode: trackingConsentMode,
    numericId: numericId,
    requestOfferAssignment: requestOfferAssignment,
    requestCommerceOffer: requestCommerceOffer,
    requestCommercePresentation: requestCommercePresentation,
    createHandoff: createHandoff,
    cartCheckoutUrl: cartCheckoutUrl,
    redirectCartToCheckout: redirectCartToCheckout,
    consentState: consentState,
    checkoutQuantity: checkoutQuantity,
    pdpSurface: pdpSurface,
    hasDiscountApplications: hasDiscountApplications
  };
})();
